import { getImportTitle } from 'common/header/notifications/hooks/mappers/impl/importMapper';
import { type NotificationMapper } from 'common/header/notifications/Notifications.types';

export const importUciMapper: NotificationMapper = (notification, options) => {
  return {
    ...notification,
    ...getImportTitle(notification, options),
    to: `/${options.tenantCode}/settings/monitoring/import-logs`
  };
};
